import { addSubscriptionHandler } from './handlers.js';
import logger from "src/utils/logger/logger.js"
/**
 * Configuration for a button displayed in a configuration modal.
 *
 * @typedef {Object} ConfigModalButton
 * @property {string} id Stable identifier used as the React key.
 * @property {string} labelKey Translation key or label consumed by ConfigMenuButton.
 * @property {Function} onClick Action executed when the button is selected.
 */

/** @type {ConfigModalButton[]} */
const MY_SUBSCRIPTIONS_BUTTONS = [
    {
        id: 'MenuAvatar_AdmSuscripciones_Texto_TextoBoton2',
        labelKey: 'MenuAvatar_AdmSuscripciones_Texto_TextoBoton2',
        onClick: addSubscriptionHandler
    },
    {
        id: 'Activar HBO max',
        labelKey: 'Activar HBO max',
        onClick: () => {
            logger.debug('My Subscriptions button clicked');
        }
    }
]

export default {
    title: 'MenuAvatar_AdmSuscripciones_Titulo_TextoTitulo',
    img: 'MenuAvatar_MenuPrincipal_Imagen_Suscripciones',
    /** @type {ConfigModalButton[]} */
    buttons: MY_SUBSCRIPTIONS_BUTTONS
};



// WEBPACK FOOTER //
// ./src/containers/config/ConfigModals/mySubscriptions/config.js